import { ExposedDropdown } from 'components/dropdown/ExposedDropdown'
import {
  CuidadoCompartilhadoSortEnum,
  ListaCuidadoCompartilhadoFilterModel,
} from 'view/cuidados-compartilhados/model-cuidadoCompartilhado'

interface ListaCuidadoCompartilhadoSortDropdownProps {
  items: CuidadoCompartilhadoSortEnum[]
  filter: ListaCuidadoCompartilhadoFilterModel
  onChange(filter: ListaCuidadoCompartilhadoFilterModel): void
}

const LCCSortMap: { [key in CuidadoCompartilhadoSortEnum]: string } = {
  [CuidadoCompartilhadoSortEnum.STATUS_EXECUTANTE]: 'Status',
  [CuidadoCompartilhadoSortEnum.STATUS_SOLICITANTE]: 'Status',
  [CuidadoCompartilhadoSortEnum.CLASSIFICACAO_DE_PRIORIDADE_EXECUTANTE]: 'Prioridade',
  [CuidadoCompartilhadoSortEnum.CLASSIFICACAO_DE_PRIORIDADE_SOLICITANTE]: 'Prioridade',
}

export function ListaCuidadoCompartilhadoSortDropdown(props: Readonly<ListaCuidadoCompartilhadoSortDropdownProps>) {
  const { items, filter, onChange } = props

  const onChangeSelect = (sort: CuidadoCompartilhadoSortEnum) => {
    onChange({
      ...filter,
      pageParams: {
        ...filter.pageParams,
        sort,
      },
    })
  }

  return (
    <ExposedDropdown<CuidadoCompartilhadoSortEnum>
      label='Ordenar por:'
      selectedItem={filter.pageParams.sort}
      items={items}
      itemToString={itemToString()}
      onChange={onChangeSelect}
    />
  )
}

const itemToString = () => (sort: CuidadoCompartilhadoSortEnum) => LCCSortMap[sort]
